export default __webpack_public_path__ + "static/media/black.e75713cc.png";